import React from "react"
import PropTypes from "prop-types"
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CreditCardElement from './CreditCardElement'

// const stripePromise = loadStripe(process.env.STRIPE_PUBLISHABLE_KEY)

class MembershipCheckout extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      planId: '',
      total: '',
      description: '',
      loaded: false,
      customerId: '',
      processingPayment: false,
      formError: '',
      stripePromise: ''
    }

    this.createSubscription = this.createSubscription.bind(this)
    this.setError = this.setError.bind(this)
  }

  async componentDidMount() {
    const stripePromise = await loadStripe(this.props.stripePublishableKey)

    this.setState({
      stripePromise: stripePromise
    })

    $.ajax({
      url: `../getStripeCustomer`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: (data) => {
        this.setState({
          customerId: data.data.customer_id,
          planId: this.props.plan_id,
          total: this.props.plan_id === 5 ? 7 : 39,
          description: this.props.plan_id === 5 ?  "Pro Lexer Plan (billed monthly)" : "Elite Lexer Plan (billed annually)",
          loaded: true
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  setError(message) {
    this.setState({
      formError: message
    })
  }

  createSubscription(paymentMethodId) {
    this.setState({
      processingPayment: true,
      formError: ''
    })

    $.ajax({
      url: `../createSubscription`,
      dataType: 'JSON',
      type: 'POST',
      header: {
        'Content-Type': 'application/json'
      },
      data: {
        paymentMethodId: paymentMethodId,
        planId: this.state.planId,
        customerId: this.state.customerId
      },
      success: (data) => {
        this.props.closeCheckout()
        this.setState({
          processingPayment: false
        })
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  render() {
    if(!this.state.loaded) {
      return(<h1>Loading</h1>)
    }
    return(
      <div style={{maxWidth: 450, margin: 'auto'}}>
        <h3 style={{color: '#0D0E10', textAlign: 'center', fontWeight: 400, marginTop: 50, marginBottom: 30}}>Your subtotal is <span className="darkBlue" style={{fontWeight: 600}}>${this.state.total}</span></h3>
        <h5 style={{color: '#0D0E10', textAlign: 'center', marginBottom: 30}}>{`Enter card details and you're ready to enjoy the Pro perks!`}</h5>
        {this.state.formError != '' && <h4 className="red" style={{height: 40}}>{this.state.formError}</h4>}
        <div style={{maxWidth: 450}}>
          <Elements stripe={this.state.stripePromise}>
            <CreditCardElement
              description={this.state.description}
              total={this.state.total}
              processingPayment={this.createSubscription}
              isProcessingPayment={this.state.processingPayment}
              setError={this.setError}
              formError={this.state.formError}
            />
          </Elements>
        </div>
      </div>
    )
  }
}

export default MembershipCheckout;
